import React from "react";
import "./topnav.css";

function TopNav() {
  return (
    <div className="topnav">
      {/* <input type="text" placeholder="Search..." className="search-bar" />
      <div className="profile">
        <img src="path-to-profile-pic.jpg" alt="Profile" className="profile-pic" />
        <span className="profile-name">User Name</span>
      </div> */}
    </div>
  );
}

export default TopNav;
